import InvoicePortalPayment from './InvoicePortalPayment';

export default InvoicePortalPayment;
